import { NotifyReact, NotifyReactEvents } from 'Phaser/EventBus2';
import Cursor from 'Phaser/GameObjects/Cursor';

export class TestExercise extends Phaser.Scene {
  progressBar?: Phaser.GameObjects.Rectangle;
  t: number = 0.0;
  cursor: Cursor | null = null;

  constructor() {
    super('TestExercise');
  }

  stop() {
    this.scene.stop();
  }

  create(): void {
    NotifyReactEvents.CurrentSceneReady(this);
  }

  init(_config: Record<string, unknown>) {}
}
